<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row" v-if="$root.user.tipo == 'contratante'">

                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-xl-5 col-lg-6 col-xs-12">
                                    <div class="fun-facts-container margin-top-0">
                                        <div class="fun-fact border-green">
                                            <div class="fun-fact-text">
                                                <a >
                                                    <span>Sua pontuação</span>
                                                    <h4>
                                                        {{$root.user.pontos}}
                                                    </h4>
                                                </a>
                                            </div>
                                            <div class="fun-fact-icon"><i class="material-icons">star</i></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-12 clearfix"></div>
                                <div class="col-lg-9 col-md-8 col-xs-12 col-xl-6">
                                    <div class="tabs tabs-default margin-top-20 margin-bottom-15">
                                        <div class="tabs-header">
                                            <ul style="width: 100%;">
                                                <li style="width: 33.33%;" v-bind:class="{'active': tab == 'todos'}">
                                                    <a v-on:click="setTab('todos')">
                                                        <i class="material-icons">card_giftcard</i>
                                                        Prêmios
                                                    </a>
                                                </li>
                                                <li style="width: 33.33%;" v-bind:class="{'active': tab == 'resgates'}">
                                                    <a v-on:click="setTab('resgates')">
                                                        <i class="material-icons">check_circle</i>
                                                        Resgates
                                                    </a>
                                                </li>
                                                <li style="width: 33.33%;" v-bind:class="{'active': tab == 'historico'}">
                                                    <a v-on:click="setTab('historico')">
                                                        <i class="material-icons">format_list_bulleted</i>
                                                        Extrato
                                                    </a>
                                                </li> 
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-8 col-xs-12" v-show="tab == 'todos'">

                            <p class="page-text margin-top-5 margin-bottom-20" style="color: #444;">
                                <b style="display: block; margin-bottom: 8px; color: #000;">
                                    <i class="material-icons" style="font-size: inherit;">help</i>
                                    Como funciona?
                                </b>
                                A cada <b>20 litros</b> nos abastecimentos você ganha <b>1 ponto</b>. Esses pontos poderão ser <b>trocados</b> por <b>prêmios</b>. <b>Agende</b> seus <b>abastecimentos</b> pelo aplicativo e <b>acumule pontos</b>!
                            </p>

                            <h5 class="block-title ">
                                <i class="material-icons">card_giftcard</i>
                                Prêmios disponíveis
                            </h5>
<!-- 
                            <div class="listings-container compact-list-layout margin-top-0">
                                <a class="job-listing">
                                    <div class="job-listing-details">
                                        <div class="job-listing-company-logo">
                                            <div class="img" style="background-image: url(static/images/premio3.jpg);"></div>
                                        </div>
                                        <div class="job-listing-description">
                                            <h3 class="job-listing-title">Boné fly</h3>
                                            <h4>110 pontos</h4>
                                            <button class="button small margin-top-10 color-green">
                                                <i class="material-icons">check_circle</i>
                                                <b>Resgatar prêmio</b>
                                            </button>
                                        </div>
                                    </div>
                                </a>
                            </div> -->                                                        

                            <div v-show="data.itens.length == 0 && loaded" class="job-overview empty margin-top-40">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum prêmio disponível. <b>Em breve</b> teremos vários prêmios para você.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="listings-container compact-list-layout margin-top-0" v-show="data.itens.length > 0">
                                <a class="job-listing" v-for="item in data.itens">
                                    <div class="job-listing-details">
                                        <div class="job-listing-company-logo">
                                            <div class="img" :style="{'background-image': 'url(' + $root.config.url + '/' + item.imagem + ')'}"></div>
                                        </div>
                                        <div class="job-listing-description">
                                            <h3 class="job-listing-title">{{item.nome}}</h3>
                                            <h4><b>{{item.pontos}}</b> pontos</h4>
                                            <button class="button disabled-opacity small margin-top-5 gray" v-if="parseFloat(item.pontos) > parseFloat($root.user.pontos)">
                                                <i class="material-icons">check_circle</i>
                                                <b>Resgatar prêmio</b>
                                            </button>   
                                            <button class="button small margin-top-5 color-green" v-on:click="resgatar(item.cod)" v-if="parseFloat(item.pontos) <= parseFloat($root.user.pontos)">
                                                <i class="material-icons">check_circle</i>
                                                <b>Resgatar prêmio</b>
                                            </button>                                                                                     
                                        </div>
                                    </div>
                                </a>
                            </div>

                        </div>

                        <div class="col-xl-8 col-lg-8 col-xs-12" v-show="tab == 'resgates'">
                            <h5 class="block-title ">
                                <i class="material-icons">check_circle</i>
                                Meus prêmios
                            </h5>

                            <div v-show="resgates.itens.length == 0 && resgates.loaded" class="job-overview empty margin-top-40">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>                            

                            <div class="listings-container compact-list-layout margin-top-0" v-show="resgates.itens.length > 0 && resgates.loaded">
<!--                                 <a class="job-listing">
                                    <div class="job-listing-details">
                                        <div class="job-listing-company-logo">
                                            <div class="img" style="background-image: url(static/images/premio3.jpg);"></div>
                                        </div>
                                        <div class="job-listing-description">
                                            <h3 class="job-listing-title">Boné fly</h3>
                                            <h4><b>40</b> pontos</h4>
                                            <span class="dashboard-status-button color-orange">Envio pendente</span>
                                            <br>
                                            <button v-on:click="openDetalhesResgate('123123123')" class="button small margin-top-5 gray">
                                                <i class="material-icons">insert_drive_file</i>
                                                <b>Ver detalhes</b>
                                            </button>
                                        </div>
                                    </div>
                                </a> -->

                                <a class="job-listing" v-for="item in resgates.itens">
                                    <div class="job-listing-details">
                                        <div class="job-listing-company-logo">
                                            <div class="img" :style="{'background-image': 'url(' + $root.config.url + '/' + item.catalogo.imagem + ')'}"></div>
                                        </div>
                                        <div class="job-listing-description">
                                            <h3 class="job-listing-title">{{item.nome}}</h3>
                                            <h4><b>{{item.catalogo.pontos}}</b> pontos</h4>

                                            <span class="dashboard-status-button color-orange" v-show="item.status == 0 && item.formaEntrega == 'retirar-no-local'">Retirada pendente</span>
                                            <span class="dashboard-status-button color-green" v-show="item.status == 2">Entregue</span>
                                            <span class="dashboard-status-button color-orange" v-show="item.status == 0 && item.formaEntrega == 'entrega'">Envio pendente</span>
                                            <span class="dashboard-status-button color-blue" v-show="item.status == 1 && item.formaEntrega == 'entrega'">Enviado</span>
                                            <br>
                                            <h5>
                                                <i class="material-icons">access_time</i>
                                                {{item.datahora | formatDate}}
                                            </h5>
                                            <button v-on:click="openDetalhesResgate(item.cod)" class="button small gray block-mobile">
                                                <i class="material-icons">insert_drive_file</i>
                                                <b>Detalhes do resgate</b>
                                            </button>
                                        </div>
                                    </div>
                                </a>

                            </div>

                        </div>

                        <div class="col-xl-12 col-xs-12" v-show="tab == 'historico'">
                            <h5 class="block-title ">
                                <i class="material-icons">list</i>
                                Extrato de pontos
                            </h5>

                            <div v-show="extrato.itens.length == 0 && extrato.loaded" class="job-overview empty margin-top-40">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="extrato.itens.length > 0">
                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 200px;">
                                            Descrição
                                        </th>
                                        <th style="min-width: 150px; width: 150px;">
                                            Pontuação
                                        </th>                                                                                                     
                                        <th style="min-width: 175px; width: 175px;">
                                            Data/hora
                                        </th>                                                                        
                                    </thead>
                                    <tbody>   
                                       
<!--                                         <tr>
                                            <td>
                                                <i class="material-icons">info</i>
                                                Abastecimento na filial Curitibanos SSKU    
                                            </td>
                                            <td>
                                                <i class="material-icons">star</i>
                                                <b>+ 50</b> pontos    
                                            </td>                     
                                            <td>
                                                <i class="material-icons">access_time</i>
                                                07/07/2020 às 12:52    
                                            </td>
                                        </tr> 
                                         --> 

                                        <tr v-for="item in extrato.itens">
                                            <td>
                                                <i class="material-icons">info</i>
                                                {{item.descricao}}
                                            </td>
                                            <td>
                                                <i class="material-icons">star</i>
                                                <b>{{item.pontos}}</b> pontos    
                                            </td>                     
                                            <td>
                                                <i class="material-icons">access_time</i>
                                                {{item.datahora | formatDate}}
                                            </td>
                                        </tr>
                                     
                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination">
                                        <ul>
                                            <li class="pagination-arrow" v-show="extrato.page > 1" v-on:click="getExtrato(extrato.page - 1);">
                                                <a>
                                                    <i class="material-icons">arrow_back</i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="extrato.page >= 1 && extrato.page < (extrato.pages.length)" v-on:click="getExtrato(extrato.page + 1);">
                                                <a>
                                                    Próxima
                                                    <i class="material-icons">arrow_forward</i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in extrato.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == extrato.page}" v-on:click="getExtrato(item.index);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>

                            </div>


<!--                             <div class="listings-container compact-list-layout margin-top-0">
                                <a class="job-listing">
                                    <div class="job-listing-details padding-left-20">
                                        <div class="job-listing-description">
                                            <h3 class="job-listing-title">Abastecimento na filial Curitibanos SSKU</h3>
                                            <h4 class="margin-top-5"><b>+ 50</b> pontos</h4>
                                            <small>
                                                <i class="material-icons">access_time</i>
                                                12/05/2020 15:33
                                            </small>
                                        </div>
                                    </div>
                                </a>
                            </div>
 -->
                        </div>                        

                    </div>

                    <div class="row" v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial') || $root.user.tipo == 'prestador'">
                        
                        <div class="col-lg-9 col-md-8 col-xs-12 col-xl-6" v-show="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial')">
                            <div class="tabs tabs-default margin-top-0 margin-bottom-25">
                                <div class="tabs-header">
                                    <ul style="width: 100%;">
                                        <li style="width: 33.33%;" v-bind:class="{'active': tab == 'todos'}">
                                            <a v-on:click="setTab('todos')">
                                                <i class="material-icons">card_giftcard</i>
                                                Prêmios
                                            </a>
                                        </li>
                                        <li style="width: 33.33%;" v-bind:class="{'active': tab == 'resgates'}">
                                            <a v-on:click="setTab('resgates')">
                                                <i class="material-icons">check_circle</i>
                                                Resgates
                                            </a>
                                        </li>
                                        <li style="width: 33.33%;" v-bind:class="{'active': tab == 'historico'}">
                                            <a v-on:click="setTab('historico')">
                                                <i class="material-icons">format_list_bulleted</i>
                                                Extrato
                                            </a>
                                        </li>                                        
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div v-show="tab == 'todos' && ($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial')" class="col-lg-12 margin-bottom-20">
                            <router-link :to="{'name': 'CadastrarPremios'}" class="button block-mobile big">
                                <i class="material-icons">add</i>
                                Cadastrar prêmio
                            </router-link>
                        </div>
                        <div v-show="tab == 'todos'" class="col-xl-12">                        

                            <div v-show="data.itens.length == 0 && loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0 && loaded">
                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 1px; width: 1px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>
                                        <th style="min-width: 80px; width: 80px;">
                                            Pontuação
                                        </th>                                                                                                     
                                        <th style="min-width: 155px; width: 155px;">
                                            Cadastro
                                        </th>  
                                        <th style="min-width: 130px; width: 130px;">
                                            Ações
                                        </th>                                                                        
                                    </thead>
                                    <tbody>   
                                        <tr v-for="item in data.itens">
                                            <td data-label="ID">
                                                <a >
                                                    {{item.id}}
                                                </a>
                                            </td>
                                            <td data-label="Nome">
                                                <a >
                                                    {{item.nome}}
                                                </a>
                                            </td>
                                            <td data-label="Pontuação">
                                                <a >
                                                    {{item.pontos}}
                                                </a>
                                            </td>                     
                                            <td data-label="Cadastro">
                                                <a >
                                                    {{item.datahoraFormatado}}
                                                </a>
                                            </td>
                                            <td data-label="Ações">
                                                <router-link :to="{'name': 'EditarPremios', 'query': {'c': item.cod}}" class="dashboard-status-button gray">Editar</router-link>                                                                                
                                                <a v-on:click="del(item.cod)" class="dashboard-status-button color-red">Apagar</a>                                                                                      
                                            </td>
                                        </tr>    

<!--                                         <tr>
                                            <td>
                                                <a >
                                                    1
                                                </a>
                                            </td>
                                            <td>
                                                <a >
                                                    <u>Camiseta Landin</u>
                                                </a>
                                            </td>
                                            <td>
                                                <a >
                                                    129
                                                </a>
                                            </td>                     
                                            <td>
                                                <a >
                                                    07/07/2020 12:52
                                                </a>
                                            </td>
                                            <td>
                                                <a class="dashboard-status-button gray">Editar</a>                                                                                      
                                                <a class="dashboard-status-button color-red">Apagar</a>                                                                                      
                                            </td>
                                        </tr>   -->                                                                                                                                               
                                  
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div v-show="tab == 'resgates'" class="col-xl-12">                        
                           
                            <div v-show="resgates.itens.length == 0 && resgates.loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <h4 class="margin-bottom-10" v-if="$root.user.tipo == 'prestador' && resgates.itens.length > 0">
                                <i class="material-icons">card_giftcard</i> 
                                <b>Retiradas pendentes</b>
                            </h4>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="resgates.itens.length > 0">
                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 1px; width: 1px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Piloto
                                        </th>
                                        <th style="min-width: 200px;">
                                            Prêmio
                                        </th>                                        
                                        <th style="min-width: 80px; width: 80px;">
                                            Pontuação
                                        </th>                                   
                                        <th style="min-width: 140px; width: 140px;">
                                            Solicitado em
                                        </th>
                                        <th style="min-width: 140px; width: 140px;">
                                            Entregue em
                                        </th>                                          
                                        <th style="min-width: 90px; width: 90px;">
                                            Ações
                                        </th>                                                                        
                                    </thead>
                                    <tbody>      

                                        <tr v-for="item in resgates.itens">
                                            <td data-label="ID">
                                                <a >
                                                    {{item.id}}
                                                </a>
                                            </td>
                                            <td data-label="Piloto">
                                                <u>{{item.contratante.nome}}</u>
                                                <div class="clearfix margin-top-5"></div>
                                                <small v-show="item.contratante.email != ''"><i class="material-icons">email</i> {{item.contratante.email}}</small>
                                                <br v-show="item.contratante.email != ''">
                                                <small v-show="item.contratante.telefone != ''"><i class="material-icons">phone</i> {{item.contratante.telefone}}</small>                                                    
                                                <br v-show="item.contratante.telefone != ''">
                                                <small v-show="item.contratante.doc != ''"><i class="material-icons">verified_user</i> {{item.contratante.doc}}</small>                                                    
                                            </td>
                                            <td data-label="Prêmio">
                                                <a >
                                                    <u>{{item.catalogo.nome}}</u>
                                                </a>
                                                <br>
                                                <small v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial') && item.formaEntrega == 'retirar-no-local' && item.empresa">
                                                    <i class="material-icons">store</i> Retirar na filial {{item.empresa.nome}}
                                                </small>
                                                <small v-show="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial') && item.formaEntrega == 'entrega'">
                                                    <i class="material-icons">local_shipping</i> Entregar no endereço do cliente
                                                </small>
                                                <br v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial') && item.formaEntrega == 'entrega' && item.entregaRastreamento != ''">
                                                <small v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial') && item.formaEntrega == 'entrega' && item.entregaRastreamento != ''">
                                                    Cód. de rastreamento: <a :href="'https://linkcorreios.com.br/' + item.entregaRastreamento" target="_blank"><u><b>{{item.entregaRastreamento}}</b></u></a>
                                                </small>                                                                                                
                                            </td>
                                            <td data-label="Pontuação">
                                                <a >
                                                    {{item.catalogo.pontos}}
                                                </a>
                                            </td>
                                            <td data-label="Solicitado em">
                                                <a >
                                                    {{item.datahora | formatDate}}
                                                    <br>
                                                    <span class="dashboard-status-button margin-top-10 color-orange" v-show="item.status == 0 && item.formaEntrega == 'retirar-no-local'">Retirada pendente</span>
                                                    <span class="dashboard-status-button margin-top-10 color-green" v-show="item.status == 2">Entregue</span>
                                                    <span class="dashboard-status-button margin-top-10 color-orange" v-show="item.status == 0 && item.formaEntrega == 'entrega'">Envio pendente</span>
                                                    <span class="dashboard-status-button margin-top-10 color-blue" v-show="item.status == 1 && item.formaEntrega == 'entrega'">Enviado</span>                                                 
                                                </a>
                                            </td>
                                            <td data-label="Entregue em">
                                                <a v-show="item.finalizado != '0000-00-00 00:00:00'">
                                                    {{item.finalizado | formatDate}}
                                                </a>
                                                <a v-show="item.finalizado == '0000-00-00 00:00:00'">
                                                    -
                                                </a>             
                                            </td>                                           
                                            <td data-label="Ações">
                                                <a class="dashboard-status-button gray margin-bottom-5" v-on:click="openDetalhesResgate(item.cod)">Detalhes</a>
                                                <a class="dashboard-status-button green margin-bottom-5" v-on:click="entregar(item.cod)" v-show="item.status == 0 && item.formaEntrega == 'retirar-no-local'">Entregar</a>
                                                <a class="dashboard-status-button green margin-bottom-5" v-on:click="enviar(item.cod)" v-show="item.status == 0 && item.formaEntrega == 'entrega'">Despachar</a>
                                                <a class="dashboard-status-button green margin-bottom-5" v-on:click="entregar(item.cod)" v-show="item.status == 1 && item.formaEntrega == 'entrega'">Concluir</a>
                                                <br class="hidden-xs">                                                                                      
                                                <a class="dashboard-status-button color-red" v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial')" v-on:click="delResgate(item.cod)">Apagar</a>                                                                                      
                                            </td>
                                        </tr> 

<!--                                         <tr>
                                            <td data-label="ID">
                                                <a >
                                                    2
                                                </a>
                                            </td>
                                            <td data-label="Piloto">
                                                <a >
                                                    <u>Rafael Silva</u>
                                                </a>
                                            </td>
                                            <td data-label="Prêmio">
                                                <a >
                                                    <u>Caneca Landin</u>
                                                </a>
                                                <br>
                                                <small>
                                                    <i class="material-icons">local_shipping</i>Enviar para o endereço do cliente.
                                                </small>
                                            </td>
                                            <td data-label="Pontuação">
                                                <a >
                                                    160
                                                </a>
                                            </td>
                                            <td data-label="Solicitado em">
                                                <a >
                                                    07/07/2020 12:52
                                                    <br>
                                                    <span class="dashboard-status-button color-orange margin-top-10">
                                                        Envio pendente
                                                    </span>                                                    
                                                </a>
                                            </td>
                                            <td data-label="Entregue em">
                                                <a >
                                                    -
                                                </a>
                                            </td>                                           
                                            <td data-label="Ações">
                                                <a class="dashboard-status-button green margin-bottom-5">Enviar</a><br class="hidden-xs">
                                                <a class="dashboard-status-button color-red">Apagar</a>                                                                                      
                                            </td>
                                        </tr>                                                                                                                                                                            -->              
                                  
                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination">
                                        <ul>
                                            <li class="pagination-arrow" v-show="resgates.page > 1" v-on:click="getResgates(resgates.page - 1);">
                                                <a>
                                                    <i class="material-icons">arrow_back</i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="resgates.page >= 1 && resgates.page < (resgates.pages.length)" v-on:click="getResgates(resgates.page + 1);">
                                                <a>
                                                    Próxima
                                                    <i class="material-icons">arrow_forward</i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in resgates.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == resgates.page}" v-on:click="getResgates(item.index);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>

                            </div>
                        </div>
                        <div v-show="tab == 'historico'" class="col-xl-12">                        

                            <div v-show="extrato.itens.length == 0 && extrato.loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="extrato.itens.length > 0">
                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 1px; width: 1px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px; width: 200px;">
                                            Piloto
                                        </th>                                        
                                        <th style="min-width: 200px;">
                                            Descrição
                                        </th>
                                        <th style="min-width: 150px; width: 150px;">
                                            Pontuação
                                        </th>                                                                                                     
                                        <th style="min-width: 175px; width: 175px;">
                                            Data/hora
                                        </th>                                                                        
                                    </thead>
                                    <tbody>   
                                       
                                        <tr v-for="item in extrato.itens">
                                            <td data-label="ID">
                                                {{item.id}}
                                            </td>
                                            <td data-label="Piloto">
                                                <u>{{item.contratante.nome}}</u>
                                            </td>
                                            <td data-label="Descrição">
                                                <i class="material-icons">info</i>
                                                {{item.descricao}}
                                            </td>
                                            <td data-label="Pontuação">
                                                <i class="material-icons">star</i>
                                                <b>{{item.pontos}}</b> pontos    
                                            </td>                     
                                            <td data-label="Data/hora">
                                                <i class="material-icons">access_time</i>
                                                {{item.datahora | formatDate}}
                                            </td>
                                        </tr>  

<!--                                         <tr>
                                            <td data-label="ID">
                                                2
                                            </td>
                                            <td data-label="Piloto">
                                                <u>Anderson Alves</u>
                                            </td>
                                            <td data-label="Descrição">
                                                <i class="material-icons">info</i>
                                                Resgate do prêmio Boné Fly
                                            </td>
                                            <td data-label="Pontuação">
                                                <i class="material-icons">star</i>
                                                <b>- 40</b> pontos    
                                            </td>                     
                                            <td data-label="Data/hora">
                                                <i class="material-icons">access_time</i>
                                                15/07/2020 às 08:52    
                                            </td>
                                        </tr>   -->                                                                                                                          
                                  
                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination">
                                        <ul>
                                            <li class="pagination-arrow" v-show="extrato.page > 1" v-on:click="getExtrato(extrato.page - 1);">
                                                <a>
                                                    <i class="material-icons">arrow_back</i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="extrato.page >= 1 && extrato.page < (extrato.pages.length)" v-on:click="getExtrato(extrato.page + 1);">
                                                <a>
                                                    Próxima
                                                    <i class="material-icons">arrow_forward</i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in extrato.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == extrato.page}" v-on:click="getExtrato(item.index);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>

                            </div>

                        </div>                                                
                    </div>

                </div>
            </div>
        </div>

        <div id="modal-detalhes-resgate" class="modal">

            <div class="row" v-if="resgate">
                <div class="col-lg-12">
                    <div class="welcome-text padding-top-20">
                        <h3>
                            <i class="material-icons">card_giftcard</i>
                            Detalhes do resgate
                        </h3>
                    </div>

                    <table class="table table-bordered table-bordered-default table-responsive table-force-responsive">
                        <tbody>      

                            <tr>
                                <td data-label="ID">
                                    {{resgate.id}}
                                </td>
                                <td data-label="Prêmio">
                                    <u>{{resgate.catalogo.nome}}</u>
                                </td>
                                <td data-label="Pontuação">
                                    {{resgate.pontos}} pontos
                                </td>
                                <td data-label="Forma de entrega do prêmio">
                                    <a v-if="resgate.formaEntrega == 'retirar-no-local' && resgate.empresa">
                                        <i class="material-icons">store</i> Retirar na filial {{resgate.empresa.nome}}
                                        <small style="display: block;">* Prazo de 35 dias para retirada.</small>
                                    </a>
                                    <a v-show="resgate.formaEntrega == 'entrega'">
                                        <i class="material-icons">local_shipping</i> Entregar no endereço
                                    </a>
                                </td>  
                                <td data-label="Código de rastreamento:" v-if="resgate.formaEntrega == 'entrega' && resgate.entregaRastreamento != ''">
                                    <a :href="'https://linkcorreios.com.br/' + resgate.entregaRastreamento" target="_blank"><u><b>{{resgate.entregaRastreamento}}</b></u></a>
                                </td>
                                <td data-label="Solicitado em">
                                    <a >
                                        {{resgate.datahora | formatDate}}
                                        <br>
                                        <span class="dashboard-status-button margin-top-10 color-orange" v-show="resgate.status == 0 && resgate.formaEntrega == 'retirar-no-local'">Retirada pendente</span>
                                        <span class="dashboard-status-button margin-top-10 color-green" v-show="resgate.status == 2">Entregue</span>
                                        <span class="dashboard-status-button margin-top-10 color-orange" v-show="resgate.status == 0 && resgate.formaEntrega == 'entrega'">Envio pendente</span>
                                        <span class="dashboard-status-button margin-top-10 color-blue" v-show="resgate.status == 1 && resgate.formaEntrega == 'entrega'">Enviado</span>                                                       
                                    </a>
                                </td>
                                <td data-label="Entregue em">
                                    <a v-show="resgate.finalizado != '0000-00-00 00:00:00'">
                                        {{resgate.finalizado | formatDate}}
                                    </a>
                                    <a v-show="resgate.finalizado == '0000-00-00 00:00:00'">
                                        -
                                    </a> 
                                </td> 
                                <td v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial')" data-label="Nome">
                                    {{resgate.contratante.nome}}
                                </td>
                                <td v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial')" data-label="E-mail">
                                    {{resgate.contratante.email}}
                                </td>
                                <td v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial')" data-label="Telefone">
                                    {{resgate.contratante.telefone}}
                                </td>
                                <td v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial')" data-label="CPF">
                                    {{resgate.contratante.doc}}
                                </td>
                                <td v-if="resgate.formaEntrega == 'entrega'" data-label="Endereço">
                                    {{resgate.entregaEndereco}}
                                </td>
                                <td v-if="resgate.formaEntrega == 'entrega'" data-label="Número">
                                    {{resgate.entregaEnderecoNumero}}
                                </td>
                                <td v-if="resgate.formaEntrega == 'entrega' && resgate.entregaEnderecoComplemento != ''" data-label="Complemento">
                                    {{resgate.entregaEnderecoComplemento}}
                                </td>
                                <td v-if="resgate.formaEntrega == 'entrega'" data-label="CEP">
                                    {{resgate.entregaEnderecoCep}}
                                </td>
                                <td v-if="resgate.formaEntrega == 'entrega'" data-label="Bairro">
                                    {{resgate.entregaEnderecoBairro}}
                                </td>
                                <td v-if="resgate.formaEntrega == 'entrega'" data-label="Cidade">
                                    {{resgate.entregaEnderecoCidade}}
                                </td>
                                <td v-if="resgate.formaEntrega == 'entrega'" data-label="Estado">
                                    {{resgate.entregaEnderecoEstado}}
                                </td>
<!--                                 <td data-label="Ações">
                                    <a class="dashboard-status-button green margin-bottom-5" onclick="window.__app.entregar()" v-show="resgate.status == 0 && resgate.formaEntrega == 'retirar-no-local'">Entregar</a>
                                    <a class="dashboard-status-button green margin-bottom-5" onclick="window.__app.enviar()" v-show="resgate.status == 0 && resgate.formaEntrega == 'entrega'">Despachar</a>
                                    <a class="dashboard-status-button green margin-bottom-5" onclick="window.__app.entregar()" v-show="resgate.status == 1 && resgate.formaEntrega == 'entrega'">Concluir</a>                                                                                     
                                    <a class="dashboard-status-button color-red" v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial')" onclick="window.__app.delResgate()">Apagar</a>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>        

        <Toolbar></Toolbar>


    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Premios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "extrato":              {
                "itens":            []
            },    
            "resgate":              null,
            "resgates":              {
                "itens":            []
            },                        
            "tab":                  "todos",
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "premio"
            }              
        }
    },
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },    
    methods: {
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;

            if (tab == "historico") {
                self.getExtrato();
            }

            if (tab == "resgates") {
                self.getResgates();
            }

        },
        entregar: function(cod) {
            console.log("entregar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja definir o prêmio como \"entregue\"?", function() {
                
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "pedidoCod":    cod,
                    "acao":         "entregar"
                };                

                self.loading.entregar   = true;
                loading.show();
                
                axios.put("api/gamification.php", form)
                .then(response => {
                    console.log("entregar() response", response)
                    self.loading.entregar    = false;
                    self.getResgates().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("entregar() error", error)
                    loading.hide();
                    self.loading.entregar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }, 
        enviar: function(cod) {
            console.log("enviar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja definir o prêmio como \"enviado\"?", function() {
                
                var texto               = prompt("Qual o código de rastreamento?");
                if (!texto)             return false; 

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "pedidoCod":    cod,
                    "texto":        texto,
                    "acao":         "enviar"
                };                       

                self.loading.enviar   = true;
                loading.show();
                
                axios.put("api/gamification.php", form)
                .then(response => {
                    console.log("enviar() response", response)
                    self.loading.enviar    = false;
                    self.getResgates().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("enviar() error", error)
                    loading.hide();
                    self.loading.entregar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },                
        resgatar: function(cod) {
            console.log("resgatar()", cod);
            var self                = this;
       
            var texto               = prompt("Você tem certeza? Informe sua senha para prosseguir.");
            if (!texto)             return false; 
            
            if (md5(texto) != self.$root.user.senha) {
                alert("A senha informada está incorreta!");
                return false;
            }

            console.log("passou");

            self.$router.push({ 
                name:       "ResgatarPremios",
                query:      {
                    "c":    cod
                }
            }).catch(()=>{});             

        },     
        openDetalhesResgate: function(cod) {
            var self        = this;

            loading.show();

            self.modalDetalhesResgate   = new tingle.modal({
                footer:         false,
                stickyFooter:   false,
                closeMethods:   ['overlay', 'button', 'escape'],
                closeLabel:     "Fechar",
                cssClass:       ["modal-detalhes-resgate"]
            });   

            var form = {
                "params": {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          cod
                }
            };

            axios.get("api/pedidos.php", form)
            .then(response => {
                
                console.log("openDetalhesResgate() response", response);
                self.resgate        = response.data.result;
                self.$forceUpdate();
                setTimeout(function() {
                    self.modalDetalhesResgate.setContent(document.querySelector('#modal-detalhes-resgate').innerHTML);          
                    self.modalDetalhesResgate.open();
                    loading.hide();
                }, 500);

            })
            .catch(error => {
                console.log("openDetalhesResgate() error", error);                    
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });   

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
           
            return new Promise(function(resolve, reject) {

                axios.get("api/catalogo.php", {params: self.form, db: "catalogo"})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getResgates: function(page) {
            var self        = this;
            console.log("getResgates()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         page ? page : 1,
                        "tipo":         "premio"
                    }
                };

                axios.get("api/pedidos.php", form)
                .then(response => {
                    
                    console.log("getResgates() response", response);
                    self.resgates       = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
    
                    self.$root.scrollTop();

                })
                .catch(error => {
                    console.log("getResgates() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getExtrato: function(page) {
            var self        = this;
            console.log("getExtrato()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         page ? page : 1,
                        "tipo":         "extrato"
                    }
                };

                axios.get("api/gamification.php", form)
                .then(response => {
                    
                    console.log("getExtrato() response", response);
                    self.extrato   = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                    self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("getExtrato() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        delResgate: function(cod) {
            console.log("delResgate()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.delResgate = true;
                loading.show();
                
                axios.delete("api/pedidos.php", {params: form})
                .then(response => {
                    console.log("delResgate() response", response)
                    self.loading.delResgate    = false;
                    self.getResgates().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });
                })
                .catch(error => {
                    console.log("delResgate() error", error)
                    loading.hide();
                    self.loading.delResgate    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/catalogo.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    beforeMount: function(e){
    },    
    created: function() {
        var self = this;

        if (self.$root.tab == "resgates" && self.$root.user.tipo == "contratante") {
                
            self.$root.tab  = null;
            loading.show();
            self.setTab("resgates");            
            // self.get();
            loading.show();
            Promise.all([
                self.get(),
                self.$root.getUser()
            ]).then(function() {
                loading.hide();
            }).catch(function(error) {
                loading.hide();
            }); 

        
        } else if (self.$root.user.tipo == "prestador") {
            
            loading.show();
            self.setTab("resgates");

        } else {
            loading.show();
            Promise.all([
                self.get(),
                self.$root.getUser()
            ]).then(function() {
                loading.hide();
            }).catch(function(error) {
                loading.hide();
            }); 
        }

    },
    mounted: function() {
        var self            = this;

    }    
}    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Premios.vue